import React, { Component } from 'react'

export default class PhoneCall extends Component {
  render() {
    return (
        <a href={`https://wa.me/`+this.props.phone} target="_blank">+{this.props.phone}</a>
    )
  }
}
